import api from "./api";

const officialCampaignService = {
  list(params = {}) {
    return api.get("/official-campaigns", { params });
  },
  show(id) {
    return api.get(`/official-campaigns/${id}`);
  },
  create(data) {
    return api.post("/official-campaigns", data);
  },
  update(id, data) {
    return api.put(`/official-campaigns/${id}`, data);
  },
  schedule(id, payload = {}) {
    return api.post(`/official-campaigns/${id}/schedule`, payload);
  },
  stats(id) {
    return api.get(`/official-campaigns/${id}/stats`);
  },
  contacts(id, params = {}) {
    return api.get(`/official-campaigns/${id}/contacts`, { params });
  },
  importContacts(id, payload = {}) {
    return api.post(`/official-campaigns/${id}/contacts/import`, payload);
  },
  createContact(id, payload = {}) {
    return api.post(`/official-campaigns/${id}/contacts`, payload);
  },
  updateContact(id, contactId, payload = {}) {
    return api.put(`/official-campaigns/${id}/contacts/${contactId}`, payload);
  },
  removeContact(id, contactId) {
    return api.delete(`/official-campaigns/${id}/contacts/${contactId}`);
  },
  templates(whatsappId) {
    return api.get(`/official-campaigns/templates/${whatsappId}`);
  },
  uploadHeaderImage(formData) {
    return api.post("/official-campaigns/header-image", formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  },
  syncTemplates(whatsappId) {
    return api.get(`/whatsapp/sync-templates/${whatsappId}`);
  },
  cancel(id) {
    return api.post(`/official-campaigns/${id}/cancel`);
  },
  restart(id) {
    return api.post(`/official-campaigns/${id}/restart`);
  },
  remove(id) {
    return api.delete(`/official-campaigns/${id}`);
  }
};

export default officialCampaignService;
